import * as React from 'react';
import { useState, useContext } from 'react';
import { Grid, Fab, Dialog, Zoom, useTheme } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';

import ApplicationLinkCard from './ApplicationLinkCard';
import { ApplicationLinkContext } from '../store/applicationLinkContext';
import ApplicationLinkForm from './ApplicationLinkForm';

const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
  },
  lastCard: {
    marginBottom: theme.spacing(10),
  },
}));

type Props = {
  applicationLinks: ApplicationLink[];
  loading: boolean;
};

const ApplicationLinkMobile: React.FC<Props> = ({
  applicationLinks,
  loading,
}: Props) => {
  const classes = useStyles();
  const [adding, setAdding] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation('applicationlinks');
  const {
    addApplicationLink,
    getApplicationLinks,
    addApplicationLinkLoading,
  } = useContext(ApplicationLinkContext);

  const handleAddSubmit = (data: ApplicationLinkFormDto) => {
    addApplicationLink(data, () => {
      setAdding(false);
      getApplicationLinks(true);
    });
  };

  const handleAddOpen = () => {
    setAdding(true);
  };

  const handleAddClose = () => {
    setAdding(false);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return (
    <Grid container spacing={3}>
      {applicationLinks.map((s, index) => (
        <Grid
          key={s.id}
          item
          xs={12}
          className={
            index === applicationLinks.length - 1 ? classes.lastCard : ''
          }
        >
          <ApplicationLinkCard applicationLink={s} loading={loading} />
        </Grid>
      ))}
      <Zoom in timeout={transitionDuration} unmountOnExit>
        <Fab
          className={classes.fab}
          color="primary"
          aria-label="add"
          onClick={handleAddOpen}
        >
          <AddIcon />
        </Fab>
      </Zoom>
      <Dialog open={adding} onClose={handleAddClose}>
        <ApplicationLinkForm
          onSubmit={handleAddSubmit}
          buttonText={t('common:add')}
          loading={addApplicationLinkLoading}
          cancelButton
          onCancel={handleAddClose}
        />
      </Dialog>
    </Grid>
  );
};

export default ApplicationLinkMobile;
